import configure from './configure'
import user from './user'
import song from './song'

const store = {
  modules: {
    configure,
    user,
    song
  }
}
export default store



// WEBPACK FOOTER //
// ./src/store/index.js